var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AboutIcon from '@mui/icons-material/ErrorOutline';
import HelpIcon from '@mui/icons-material/Help';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from 'Routes';
import MenuIcon from 'assets/hamburger-icon.svg';
import { useAuthService } from 'ui-lib';
import makeStyles from '@mui/styles/makeStyles';
import { useMultiAuth } from 'ui-lib';
var useClasses = makeStyles({
    buttonOverride: {
        padding: 0,
    },
    menuRow: {
        display: 'grid',
        gridTemplateColumns: '[icon] 20px [spacer] 10px [text] 1fr',
        padding: '20px',
        width: '100%',
        color: 'black',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
            color: '#00539D',
        },
    },
    icon: {
        gridArea: 'icon',
    },
    text: {
        gridArea: 'text',
    },
    logoutWrapper: {
        padding: 16,
    },
    logoutButton: {
        width: '100%',
    },
});
var IconMenuItem = function (_a) {
    var Icon = _a.Icon, text = _a.text, to = _a.to, rest = __rest(_a, ["Icon", "text", "to"]);
    var classes = useClasses();
    return (_jsxs(Link, __assign({ className: classes.menuRow, to: to || '' }, rest, { children: [_jsx(Icon, { className: classes.icon }), _jsx(Typography, __assign({ className: classes.text }, { children: text }))] })));
};
export var HamburgerMenu = function () {
    var _a = useMultiAuth(), userState = _a.userState, globalSignOut = _a.globalSignOut;
    var classes = useClasses();
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var authService = useAuthService();
    var isLoggedIn = userState.isLoggedIn;
    var navigate = useNavigate();
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var menuItemClicked = function () {
        setAnchorEl(null);
    };
    var onHeaderClick = function (routes) {
        if (routes == ROUTES.HOME) {
            logOut();
        }
        else {
            navigate(routes);
        }
    };
    var logOut = function () {
        menuItemClicked();
        globalSignOut();
    };
    return (_jsxs(Box, { children: [_jsx(Button, __assign({ className: classes.buttonOverride, "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: handleClick }, { children: _jsx("img", { src: MenuIcon, alt: "Menu" }) })), _jsxs(Menu, __assign({ id: "simple-menu", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: menuItemClicked }, { children: [_jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.PROFILE); } }, { children: _jsx(IconMenuItem, { Icon: AccountCircleIcon, text: "My Profile", to: ROUTES.PROFILE }) })), _jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.PRIVACY_POLICY); } }, { children: _jsx(IconMenuItem, { Icon: LockOpenIcon, text: "Privacy Policy", to: ROUTES.PRIVACY_POLICY }) })), _jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.TERMS_OF_USE); } }, { children: _jsx(IconMenuItem, { Icon: AssignmentIcon, text: "Terms of Use", to: ROUTES.TERMS_OF_USE }) })), _jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.HELP); } }, { children: _jsx(IconMenuItem, { Icon: HelpIcon, text: "Help", to: ROUTES.HELP }) })), _jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.ABOUT); } }, { children: _jsx(IconMenuItem, { Icon: AboutIcon, text: "About", to: ROUTES.ABOUT }) })), _jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.SERVER_INFO); } }, { children: _jsx(IconMenuItem, { Icon: AboutIcon, text: "Server Info", to: ROUTES.SERVER_INFO }) })), _jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.USER_INFO); } }, { children: _jsx(IconMenuItem, { Icon: AboutIcon, text: "User Info", to: ROUTES.USER_INFO }) })), !isLoggedIn && (_jsx(MenuItem, __assign({ onClick: function () { return onHeaderClick(ROUTES.AUTH_ORG); } }, { children: _jsx(IconMenuItem, { Icon: AboutIcon, text: "Login", to: ROUTES.AUTH_ORG }) }))), _jsx(Box, __assign({ className: classes.logoutWrapper }, { children: _jsx(Button, __assign({ className: classes.logoutButton, onClick: function () { return logOut(); }, color: "primary", variant: "contained" }, { children: "Sign Out" })) }))] }))] }));
};
